/**
 * @generated SignedSource<<9fc440d8afc771d5bef7297e96d77dba>>
 * @relayHash df6009249d7d3d35364a5e60ca174780
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/575.0.0-2026-09-01T15:23:21.554Z/ProductImageCarouselRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductImageCarouselRefetchQuery$variables = {
  fetchPhotos?: boolean | null;
  itemId: string;
};
export type ProductImageCarouselRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"ProductImageCarouselRefetch_viewer">;
  };
};
export type ProductImageCarouselRefetchQuery = {
  response: ProductImageCarouselRefetchQuery$data;
  variables: ProductImageCarouselRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "fetchPhotos"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductImageCarouselRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchPhotos",
                "variableName": "fetchPhotos"
              },
              (v1/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProductImageCarouselRefetch_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ProductImageCarouselRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "fetchPhotos",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v1/*:: as any*/)
                ],
                "concreteType": "ItemPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "masterOrZoomPath",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "smallPath",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhotoVersion",
                    "kind": "LinkedField",
                    "name": "versions",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "webPath",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/575.0.0-2026-09-01T15:23:21.554Z/ProductImageCarouselRefetchQuery",
    "metadata": {},
    "name": "ProductImageCarouselRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "da41128a7beb292e1c821e705541b6e5";

export default node;
